<form
  [formGroup]="form()"
  [ngClass]="containerClass()"
  (ngSubmit)="onSubmit()"
  class="dynamic-form"
>
  @for (field of fields(); track field.key; let last = $last) {
    @if (!inEditorMode()) {
      <div
        [ngClass]="{ 'mb-0': last }"
        class="form-field-container"
      >
        <ng-container *ngTemplateOutlet="formFieldTemplate; context: { field }">
        </ng-container>
      </div>
    } @else {
      <app-field-edit-container [field]="field">
        <ng-container
          *ngTemplateOutlet="
            formFieldTemplate;
            context: { styleClass: 'flex-grow-1 mx-3', field }
          "
        >
        </ng-container>
      </app-field-edit-container>
    }
  }

  @if (fields().length > 0 && totalScoreDisplayed() && !inEditorMode()) {
    <div
      class="grand-total mt-4 text-white p-3 d-flex align-items-center justify-content-between"
    >
      <div class="d-flex align-items-center">
        <span
          class="fw-bold ms-2 text-uppercase"
          translate
          >JuryForm.Field.GrandTotal</span
        >
      </div>
      <span class="fw-bold">{{ score()?.totalScore | scoreFormat }}</span>
    </div>
  }

  @if (submitBtnDisplayed()) {
    <div class="modal-footer justify-content-center">
      <button
        class="btn btn-outline-secondary"
        translate
      >
        Cancel
      </button>

      <button
        class="btn btn-primary"
        type="submit"
        translate
      >
        {{ submitText() }}
      </button>
    </div>
  }
</form>

<ng-template
  #formFieldTemplate
  let-field="field"
  let-styleClass="styleClass"
>
  <app-form-field
    [ngClass]="styleClass"
    [field]="field"
    [form]="form()"
    [inEditorMode]="inEditorMode()"
    [errorsDisplayedOnSave]="errorsDisplayedOnSave()"
    [formSubmitted]="formSubmitted()"
  />
</ng-template>
